module.exports = __webpack_public_path__ + "static/media/brandon.66d746d6.jpg";